export const HEARING_TARGET_ORDERER = 1
export const HEARING_TARGET_ADMIN = 2
export const HEARING_TARGET_ONWER = 4
export const HEARING_TARGET_OTHER = 8

export const HEARING_TARGETS = [
  {
    id: HEARING_TARGET_ORDERER,
    text: '発注者',
  },
  {
    id: HEARING_TARGET_ADMIN,
    text: '管理者',
  },
  {
    id: HEARING_TARGET_ONWER,
    text: '所有者',
  },
  {
    id: HEARING_TARGET_OTHER,
    text: 'その他',
  },
]
